import { HttpContextToken } from '@angular/common/http';

export const SKIP_FORBIDDEN_PAGE: HttpContextToken<boolean> = new HttpContextToken<boolean>((): boolean => false);
